import { Component, OnInit, OnDestroy } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { UserserviceService } from "src/app/Services/userservice.service";
import { ToastrService } from "ngx-toastr";
import { AuthModalService } from "src/app/Services/auth-modal.service";
import { EventEmitterService } from "src/app/Services/event-emitter.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-flow-access-request",
  templateUrl: "./flow-access-request.component.html",
  styleUrls: ["./flow-access-request.component.scss"],
})
export class FlowAccessRequestComponent implements OnInit, OnDestroy {
  userData: any;
  flowData: any;
  flowCoverImageUrl: string = "";
  requestMessage: string = "";
  requesterName: string = "";
  requesterEmail: string = "";
  isSubmitting: boolean = false;
  showLoginPrompt: boolean = false;
  private loginSubscription?: Subscription;

  constructor(
    private flowServiceService: FlowServiceService,
    private userserviceService: UserserviceService,
    private router: Router,
    private toastr: ToastrService,
    private authModalService: AuthModalService,
    private eventEmitterService: EventEmitterService,
    public dialogRef: MatDialogRef<FlowAccessRequestComponent>
  ) {
    this.flowData = JSON.parse(localStorage.getItem("flowData"));
  }

  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    
    // Set flow cover image URL if available
    if (this.flowData && this.flowData.coverImageUrl) {
      this.flowCoverImageUrl = this.flowData.coverImageUrl;
    } else {
      // Default background image or gradient
      this.flowCoverImageUrl = "linear-gradient(135deg, #667eea 0%, #764ba2 100%)";
    }
    
    if (this.userData) {
      this.requesterName = this.userData.firstName || this.userData.userName || "";
      this.requesterEmail = this.userData.emailAddress || "";
    } else {
      this.showLoginPrompt = true;
    }

    this.loginSubscription =
      this.eventEmitterService.setLoggedInUserDataProperty.subscribe(
        (loggedIn) => {
          if (loggedIn) {
            this.refreshLoggedInUser();
          }
        }
      );
  }

  ngOnDestroy(): void {
    this.loginSubscription?.unsubscribe();
  }

  private refreshLoggedInUser(): void {
    try {
      this.userData = JSON.parse(localStorage.getItem("LoggedInUser") || "null");
    } catch {
      this.userData = null;
    }

    if (this.userData) {
      this.showLoginPrompt = false;
      this.requesterName = this.userData.firstName || this.userData.userName || "";
      this.requesterEmail = this.userData.emailAddress || "";
    }
  }

  requestAccess() {
    if (this.isSubmitting) return;

    if (!this.requesterName || !this.requesterEmail) {
      this.toastr.error("Please provide your name and email address.");
      return;
    }

    if (!this.requestMessage.trim()) {
      this.toastr.error("Please provide a message for your access request.");
      return;
    }

    this.isSubmitting = true;

    const requestData = {
      flowId: this.flowData.rowKey,
      flowOwnerEmail: this.flowData.customerEmail,
      requesterEmail: this.requesterEmail,
      requesterName: this.requesterName,
      requesterUserName: this.userData?.userName || "",
      requestMessage: this.requestMessage.trim()
    };

    this.flowServiceService.requestFlowAccess(requestData).subscribe(
      (response) => {
        this.toastr.success("Access request submitted successfully!");
        this.dialogRef.close(true);
        this.isSubmitting = false;
      },
      (error) => {
        console.error("Error submitting access request:", error);
        this.toastr.error("Failed to submit access request. Please try again.");
        this.isSubmitting = false;
      }
    );
  }

  goToLogin() {
    this.authModalService.openModal("login", this.router.url);
  }

  close() {
    this.dialogRef.close(false);
  }
}
